import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Grid,
  IconButton,
} from "@mui/material";
import React from "react";
import { useLoaderData, useNavigate } from "react-router-dom";

import SyncIcon from "@mui/icons-material/Sync";

import useGetPageInfo from "../../../../common/hooks/useGetPageInfo";
import BreadcrumbsComponent from "../../../../components/shared/breadcrumbs";
import EnhancedTable from "../../../../components/shared/table";

const CompletedRequestPage = () => {
  const pageInfo = useGetPageInfo();

  const dataList = useLoaderData("root");

  let navigate = useNavigate();

  const headCells = [
    {
      id: "updateOn",
      label: "تاریخ",
      type: "date",
    },
    {
      id: "adminComment",
      label: "یادداشت مدیر",
    },
    {
      id: "projectOwnerFirstName",
      label: "نام",
    },
    {
      id: "projectOwnerLastName",
      label: "نام خانوادگی",
    },
    {
      id: "projectOwnerMobile",
      label: "موبایل",
    },
    {
      id: "projectOwnerTelephon",
      label: "تلفن",
    },
    {
      id: "projectOwnerEmail",
      label: "ایمیل",
    },
    {
      id: "projectTitle",
      label: "عنوان پروژه",
    },
    {
      id: "referenceID",
      label: "شناسه درخواست",
    },
    {
      id: "note",
      label: "شرح",
    },
    {
      id: "agreementKind",
      label: "نوع توافق",
    },
    {
      id: "projectKind",
      label: "نوع درخواست",
    },
    {
      id: "requestConfirm",
      label: "وضعیت درخواست",
    },
    {
      id: "cityName",
      label: "شهرستان",
    },
    {
      id: "substationName",
      label: "ایستگاه",
    },
    {
      id: "feederName",
      label: "فیدر",
    },
    {
      id: "stepTitle",
      label: "مرحله فعلی",
    },
    {
      id: "isActive",
      label: "وضعیت",
      type: "boolean",
    },
  ];

  const onEditClicked = (row) => {
    navigate(`${row.id}`);
  };

  const onFetchData = () => {
    navigate();
  };

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={12}>
        <BreadcrumbsComponent />
      </Grid>

      <Grid item xs={12} md={12}>
        <Card>
          <CardHeader
            title={pageInfo.title}
            action={
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  width: "fit-content",
                }}
              >
                <IconButton
                  variant="text"
                  color="primary"
                  onClick={onFetchData}
                >
                  <SyncIcon />
                </IconButton>
              </Box>
            }
          />

          <CardContent>
            <Grid container>
              <Grid item xs={12} md={12}>
                <EnhancedTable
                  rowKey={"id"}
                  rows={dataList}
                  headCells={headCells}
                  defaultSort={{ orderBy: "updateOn", order: "desc" }}
                  pageSize={100}
                  actions={[ 
                  ]}
                />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default CompletedRequestPage;
